import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication

//Calendar
//Chat
//Ecommerce

//Project

// Tasks

//Crypto

//TicketsList
//Crm

//Invoice

//Mailbox

// Dashboard Analytics
import DashboardAnalyticsReducer from "./dashboardAnalytics/reducer";
import websiteReducer from "./website/reducer";

// Dashboard CRM

// Dashboard Ecommerce

// Dashboard Cryto

// Dashboard Cryto

// Dashboard NFT

// Pages > Team

// File Manager

// To do

// API Key
import userReducer from "./user/reducer";
import vendorReducer from "./vendor/reducer";
import adminReducer from "./admin/reducer";
import workReducer from "./employee/work/reducer";
const rootReducer = combineReducers({
  Layout: LayoutReducer,
  DashboardAnalytics: DashboardAnalyticsReducer,
  user: userReducer,
  vendor: vendorReducer,
  admin: adminReducer,
  website: websiteReducer,
  work: workReducer,
});

export default rootReducer;
